import env from "./env";

// const FOOD_APP_URL = "https://myevent.banquetfirst.com"

export const domainConfig = Object.freeze({
  loginAsUserUrl: env.LOGIN_AS_USER_URL,
  foodAppUrl: env.FOOD_APP_URL,
});